<template>
  <div class="AtlasErrorPage">
    <main class="AtlasError" :class="`AtlasError--${type}`">
      <atlas-icon class="AtlasError-icon" :name="icon" :size="100" />

      <h1 class="AtlasError-title">{{ titleText }}</h1>

      <p class="AtlasError-message" v-if="message">{{ message }}</p>
    </main>

    <atlas-footer />
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'atlas-error-page',

  props: {
    title: {
      type: String,
    },

    status: {
      type: Number,
    },

    message: {
      type: String,
    },
  },

  data: () => ({
    originalTitle: null,
  }),

  computed: {
    type() {
      if (this.status === 404) return 'notFound';
      return this.status >= 500 ? 'server' : 'client';
    },

    icon() {
      return {
        notFound: 'help-circle',
        client: 'warning',
        server: 'error',
      }[this.type];
    },

    titleText() {
      return [this.status, this.title].filter((x) => x).join(': ');
    },
  },

  methods: {
    ...mapMutations('ui', ['setDocumentTitle']),
  },

  created() {
    this.originalTitle = this.$store.state.ui.documentTitle;

    this.setDocumentTitle({ title: this.title });
  },

  updated() {
    this.setDocumentTitle({ title: this.title });
  },

  unmounted() {
    this.setDocumentTitle({ title: this.originalTitle });
  },
};
</script>

<style lang="scss">
.AtlasErrorPage {
  position: relative;
  height: 100vh;
  min-height: 700px;
  padding-bottom: $footer-height;

  .AtlasFooter {
    @include position(absolute, null 0 0 0);
  }
}

.AtlasError {
  @include position(absolute, 50% null null 50%);
  width: 100%;
  max-width: 500px;
  padding: 2em $gutter;
  border: solid 1px #ccc;
  background-color: color(bg);
  border-radius: 3px;
  text-align: center;
  transform: translateX(-50%) translateY(-50%);

  &--client {
    border: 0;
    background-color: color(warning);
  }

  &--server {
    @include antialias;
    border: 0;
    background-color: color(error);
    color: color(white);
  }

  &-icon {
    margin-bottom: 1em;

    .AtlasError--notFound & {
      color: color(disabled);
    }
  }

  &-title {
    margin: 0;
  }

  &-message {
    margin: 0.5em 0 0;
  }
}
</style>
